import { ErrorResponse, QueryKeyStrict } from '../api/types';
import { LoadingMessage, MessagesConfig } from '../types/useStatusMessage';
import useStatusMessage from './useStatusMessage';

type MessagesConfigWithCallbacks<D> = Omit<MessagesConfig, 'method' | 'key'> & {
  onSuccess?: (data: D) => void,
  onError?: (err: ErrorResponse) => void,
}

export const useInjectStatusMessagesInCallbacks = <D>(key: QueryKeyStrict, config: MessagesConfigWithCallbacks<D>): LoadingMessage => {
  const { loadingMessage, successMessage, errorMessage } = useStatusMessage({ key, silent: config.silent, messages: config.messages });

  const _onSuccess = config.onSuccess;
  config.onSuccess = (...args) => {
    successMessage();
    _onSuccess?.(...args);
  };

  const _onError = config.onError;
  config.onError = (...args) => {
    errorMessage(undefined, args[0]);
    _onError?.(...args);
  };

  return loadingMessage;
};
